import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function ExportDataSection({ onExport }) {
  const { t } = useTranslation();
  return (
    <section className="dashboardSettingsSection">
      <h3>{t('settings.exportData')}</h3>
      <p className="settingsHint">{t('settings.exportDataDesc')}</p>
      <button type="button" className="settingsExportBtn" onClick={onExport}>{t('settings.exportButton')}</button>
    </section>
  );
}

export function AddressesSection({ addresses, loading }) {
  const { t } = useTranslation();
  return (
    <section className="dashboardSettingsSection">
      <h3>{t('settings.savedAddresses')}</h3>
      <p className="settingsHint"><Link to="/dashboard/addresses">{t('settings.manageAddresses')}</Link></p>
      {loading ? (
        <p className="settingsHint">{t('common.loading')}</p>
      ) : addresses.length === 0 ? (
        <p className="settingsHint">{t('settings.noSavedAddresses')}</p>
      ) : (
        <ul className="settingsAddressList">
          {addresses.map((addr) => (
            <li key={addr.id} className="settingsAddressItem">
              {addr.label && <strong>{addr.label}</strong>}
              <span>{addr.fullAddress || [addr.area, addr.city, addr.state].filter(Boolean).join(', ')}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export function NotifPrefsSection({ notifPrefs, loading, onToggle, newsletterSubscribed, onToggleNewsletter }) {
  const { t } = useTranslation();
  return (
    <section className="dashboardSettingsSection">
      <h3>{t('settings.notificationPreferences')}</h3>
      <div className="settingsNotifPrefs">
        <label>
          <input type="checkbox" checked={notifPrefs.offers} onChange={(e) => onToggle({ ...notifPrefs, offers: e.target.checked })} disabled={loading} />
          {t('settings.newOffers')}
        </label>
        <label>
          <input type="checkbox" checked={notifPrefs.messages} onChange={(e) => onToggle({ ...notifPrefs, messages: e.target.checked })} disabled={loading} />
          {t('settings.newMessages')}
        </label>
        <label>
          <input type="checkbox" checked={notifPrefs.priceDrops} onChange={(e) => onToggle({ ...notifPrefs, priceDrops: e.target.checked })} disabled={loading} />
          {t('settings.priceDrops')}
        </label>
      </div>
      <div className="settingsNotifPrefs" style={{ marginTop: 12, borderTop: '1px solid #eee', paddingTop: 12 }}>
        <label>
          <input
            type="checkbox"
            checked={newsletterSubscribed}
            onChange={(e) => onToggleNewsletter(e.target.checked)}
          />
          {t('settings.newsletterSubscription')}
        </label>
      </div>
    </section>
  );
}
